// extracted by mini-css-extract-plugin
export var arrow = "_20-4";
export var arrowButton = "_20-6";
export var columnResizer = "_20-a";
export var columnResizerActive = "_20-b";
export var columnResizerIndicator = "_20-c";
export var columnResizerIndicatorActive = "_20-d";
export var headerCell = "_20-0";
export var help = "_20-3";
export var hoverArrow = "_20-5";
export var icon = "_20-2";
export var iconButton = "_20-9";
export var iconWrapper = "_20-8";
export var noBorder = "_20-e";
export var sortableHeaderCell = "_20-1";
export var textButton = "_20-7";